import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import ZergRushBanner from '@/common/components/blocks/ZergRushBanner/ZergRushBanner';
import Snack from '@/common/components/molecules/Snack/Snack';
import { ROUTE_SCANBAT, ROUTE_STANDALONE } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import { NotificationsContextProvider } from '@/common/contexts/NotificationsContext/NotificationsContext';
import { SearchContextProvider } from '@/common/contexts/SearchContext';
import BackToTop from '@/ebat/components/blocks/BackToTop/BackToTop';
import Footer from '@/ebat/components/blocks/Footer/Footer';
import Header from '@/ebat/components/blocks/Header/Header';
import { HeaderMenuContextProvider } from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

import {
  DefaultLayoutDefaultProps,
  DefaultLayoutPropTypes,
} from './DefaultLayout.proptypes';

const DefaultLayout = ({ children }) => {
  const { t } = useTranslation();
  const { zergRush, user, logout } = useAuth();
  const { isLoggedIn } = useAuth();

  const isScanbat = useMemo(
    () => window.location.pathname.includes(ROUTE_SCANBAT),
    [],
  );

  const isStandalone = useMemo(
    () => window.location.pathname.includes(ROUTE_STANDALONE),
    [],
  );

  if (!isLoggedIn || isScanbat || isStandalone) {
    return children;
  }
  if (
    !isScanbat &&
    !isStandalone &&
    user?.roles?.includes('ROLE_CUSTOMER_GUEST') &&
    user?.roles?.includes('ROLE_SB')
  ) {
    logout();
    toast.error(
      <Snack message={t('common:messages:login.authentication.not_allowed')} />,
    );
  }

  // const isConnected = useMemo(() => isLoggedIn && !isScanbat && !isStandalone, []);
  return (
    <NotificationsContextProvider>
      <HeaderMenuContextProvider>
        <SearchContextProvider>
          <Header />
          {zergRush && (
            <ZergRushBanner
              message={t('common:messages:zerg_rush.price_and_stock.banner')}
            />
          )}
          {children}
          <BackToTop />
          <Footer />
        </SearchContextProvider>
      </HeaderMenuContextProvider>
    </NotificationsContextProvider>
  );
};

DefaultLayout.defaultProps = {
  ...DefaultLayoutDefaultProps,
};

DefaultLayout.propTypes = {
  ...DefaultLayoutPropTypes,
};

export default DefaultLayout;
